import { useEffect, useState } from 'react';
import { Cradle, TrendData } from '@solo/app-core';
import { Flex, Text } from '@/app/ui/atoms';
import { useCradle } from '@/app/contexts';
import CustomLineChart, { LineChartData } from '@/app/ui/organisms/CustomLineChart/CustomLineChart';
import { translate } from '@/app/i18n';
import { PlaysByMonth } from '@/app/utils/MonthNumberToName';

const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
];

export type UsageData = {
  [key: string]: PlaysByMonth;
};

const UsageTrend = () => {
  const { statisticsBloc } = useCradle<Cradle>();
  const [usagesData, setUsagesData] = useState<LineChartData>({});

  // const digitalPlatforms =
  //   digitalDistributionState.kind === 'LoadedDigitalDistributionState'
  //     ? digitalDistributionState.platforms
  //     : [];

  async function getTrends(platform?: string) {
    const trends = await statisticsBloc.getTrends({ limit: 100, platform });
    const playsByYear: LineChartData = {};
    const groupedByYear = trends.reduce((acc, trend) => {
      acc[trend.year.toString()] = acc[trend.year.toString()] || [];
      acc[trend.year.toString()].push(trend);
      return acc;
    }, {} as Record<string, TrendData[]>);

    Object.entries(groupedByYear).forEach(([y, t]) => {
      const values = [];
      for (let i = 0; i < months.length; i += 1) {
        const value = t.find(({ month }) => month === i);
        values.push({ x: months[i], y: value ? value.plays : 0 });
      }
      playsByYear[y] = values;
    });
    setUsagesData(playsByYear);
  }

  useEffect(() => {
    getTrends();
  }, []);

  return (
    <Flex.Container flexDirection="column" className="mt-5" gap="2.5rem">
      {/* <Flex.Container style={{ width: '20%' }} gap="1rem">
        <InputTextAutocomplete
          placeholder="Platform..."
          items={[{ value: 'All', label: 'All' }].concat(
            digitalPlatforms.map((p) => ({ value: p.id.toString(), label: p.name })),
          )}
          onChange={(groupFilter) => (groupFilter === 'All' ? getTrends() : getTrends(groupFilter))}
        />
      </Flex.Container> */}
      {Object.keys(usagesData).length === 0 && (
        <Text.Anotation>{translate('USAGES.NO_DATA')}</Text.Anotation>
      )}
      <CustomLineChart yaxis="Plays" data={usagesData} />
    </Flex.Container>
  );
};

export default UsageTrend;
